import { AbSet } from "abweb/collection/AbSet";
import { UserInfoBase } from "abweb/dto/generated/user/UserInfoBase";
import { DeserializeContext } from "abweb/utils/json/DeserializeContext";

// Values taken from comment in emms-dispatch-security.xml
export let BuiltInUserRoles = /*#__PURE__*/function (BuiltInUserRoles) {
  BuiltInUserRoles["Admin"] = "51";
  BuiltInUserRoles["DefaultReadGroup"] = "52";
  BuiltInUserRoles["UnrestrictedSearchGroup"] = "53";
  BuiltInUserRoles["Editor"] = "54";
  BuiltInUserRoles["Anonymous"] = "55";
  BuiltInUserRoles["User"] = "56";
  BuiltInUserRoles["Importer"] = "57";
  BuiltInUserRoles["Approver"] = "58";
  BuiltInUserRoles["ProfileViewData"] = "63";
  BuiltInUserRoles["MCW"] = "64";
  BuiltInUserRoles["MSQLW"] = "65";
  BuiltInUserRoles["ModelReader"] = "66";
  return BuiltInUserRoles;
}({});
export class UserInfo extends UserInfoBase {
  static createAnonymousUser() {
    const anonymousUserData = {
      authenticated: false,
      username: "guest",
      displayName: "guest",
      usesSSO: false,
      passwordExternallyManaged: true,
      roles: [{
        id: BuiltInUserRoles.Anonymous,
        name: "Anonymous"
      }, {
        id: BuiltInUserRoles.DefaultReadGroup,
        name: "Default Read Role"
      }]
    };
    const anonymousUser = new UserInfo();
    anonymousUser.initFromJson(anonymousUserData, new DeserializeContext());
    return anonymousUser;
  }
  static createUserInfo(displayName, roles, username) {
    const retVal = new UserInfo();
    retVal.initUserInfo(true, displayName, /*passwordExternallyManaged*/false, roles, username, /*usesSSO*/false);
    return retVal;
  }
  get isAnonymous() {
    return !this.authenticated;
  }

  // Used by test setup
  initUserInfoForTest(username = "guest", displayName = "guest", roles = [], passwordExternallyManaged = false, usesSSO = false) {
    this.initUserInfo(username !== "guest", displayName, passwordExternallyManaged, roles, username, usesSSO);
  }
  constructor() {
    super();
  }

  /**
   * Checks to see if the User has all of the requested role names. True if no role names passed
   *
   * @public
   * @param {string[]} roleNames 
   * @returns {boolean} 
   */
  hasAllRolesByName(roleNames) {
    const userRoleNames = AbSet.from(this.roles.map(role => role.name)); // TODO: cache the set?
    const requireRoles = AbSet.from(roleNames);
    return requireRoles.isSubsetOf(userRoleNames);
  }

  /**
   * Checks to see if the User has at least one of the requested role names. True if no role names passed
   *
   * @public
   * @param {string[]} roleNames 
   * @returns {boolean} 
   */
  hasAnyRolesByName(roleNames) {
    if (roleNames.length === 0) {
      return true;
    }
    const userRoleNames = AbSet.from(this.roles.map(role => role.name)); // TODO: cache the set?
    const requireRoles = AbSet.from(roleNames);
    return requireRoles.intersection(userRoleNames).size > 0;
  }
}
//# sourceMappingURL=UserInfo.js.map
